import { apiGet } from '../../../generic/Api_Functions'

// Contract fixed by Sun for HU-02 (MIC-4123, D6 in
// mic-user-stories/stories/56-block-warehouse-moves-camera-cancel-moves/02-reglas.md).
// Controller: PartRest.getPendingMovesCounts(Long partId), @PreAuthorize('CANCEL_PART').
//   GET /endpoints/part/{partId}/pendingMoves
//   -> 200 PendingMovesCount { toCancel: number, inProgress: number }
//      toCancel:   count of not-started CommandMove (RN10) that WILL be cancelled on confirm.
//      inProgress: count of started-but-unfinished CommandMove (RN11) that cancelPart now also
//                  aborts/cancels on confirm (see CancelPartDialog's "in progress" warning text).
//      Finished/already-cancelled Command (RN12) are not counted; a part with no active fixture
//      degrades to { toCancel: 0, inProgress: 0 } (RN9/D5).
export const EMPTY_PENDING_MOVES = { toCancel: 0, inProgress: 0 }

// D10 (accepted staleness): if the read fails, we degrade to "no pending moves known" rather
// than blocking the dialog — the confirmation step (V3, RN13) still protects the actual
// cancellation on the backend even if this count turns out to be stale or unavailable.
export const getPartPendingMoves = async (partId) => {
  try {
    const result = await apiGet('part/' + partId + '/pendingMoves')
    return { ...EMPTY_PENDING_MOVES, ...result }
  } catch (error) {
    // Degrading is intentional (see above), but leave a trace so a missing/broken
    // endpoint is diagnosable instead of silently showing "no pending moves".
    console.error('Could not read pending moves for part ' + partId + ':', error.message || error)
    return EMPTY_PENDING_MOVES
  }
}
